var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon-quote",attrs:{"width":"22","height":"17","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 16.452L4.438 0h6.214L8.285 16.452H0zm10.948 0L15.386 0H21.6l-2.367 16.452h-8.285z","fill":_vm.fill,"fill-rule":"evenodd"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d67533d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/icons/icon-quote.vue
// module id = null
// module chunks = 